import { getCurrencySymbols, longLangCodes, preferenceBasedLongDateFormats } from '@concur/intl-core';
import { prefDelimiters } from '../mapper';
function getIntlSign(legacyNegativeFormat) {
    return legacyNegativeFormat === 1 ? 'accounting' : 'standard';
}
export function getPreferences(pref) {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q, _r, _s;
    if (pref === void 0) { pref = {}; }
    var sapUiLanguage = pref["sap-ui-language"], currencyFormat = pref.currencyFormat, dateFormat = pref.dateFormat, numberFormat = pref.numberFormat, timeFormat = pref.timeFormat, calendarFormat = pref.calendarFormat;
    return {
        currencyFormat: {
            baseCurrency: (_a = currencyFormat === null || currencyFormat === void 0 ? void 0 : currencyFormat.baseCurrency) !== null && _a !== void 0 ? _a : 'USD',
            currencySign: (_b = currencyFormat === null || currencyFormat === void 0 ? void 0 : currencyFormat.currencySign) !== null && _b !== void 0 ? _b : 'standard',
            symbolLocation: (_c = currencyFormat === null || currencyFormat === void 0 ? void 0 : currencyFormat.symbolLocation) !== null && _c !== void 0 ? _c : 'before',
            currencySymbol: (_d = currencyFormat === null || currencyFormat === void 0 ? void 0 : currencyFormat.currencySymbol) !== null && _d !== void 0 ? _d : '$',
        },
        dateFormat: dateFormat !== null && dateFormat !== void 0 ? dateFormat : {},
        locale: (_e = pref.locale) !== null && _e !== void 0 ? _e : 'en',
        messages: (_f = pref.messages) !== null && _f !== void 0 ? _f : {},
        numberFormat: {
            delimiters: (_g = numberFormat === null || numberFormat === void 0 ? void 0 : numberFormat.delimiters) !== null && _g !== void 0 ? _g : prefDelimiters[0],
            numberSign: (_h = numberFormat === null || numberFormat === void 0 ? void 0 : numberFormat.numberSign) !== null && _h !== void 0 ? _h : 'standard',
        },
        timeFormat: {
            hour12: (_j = timeFormat === null || timeFormat === void 0 ? void 0 : timeFormat.hour12) !== null && _j !== void 0 ? _j : true,
            timeSeparator: (_k = timeFormat === null || timeFormat === void 0 ? void 0 : timeFormat.timeSeparator) !== null && _k !== void 0 ? _k : ':',
            timeZone: (_l = timeFormat === null || timeFormat === void 0 ? void 0 : timeFormat.timeZone) !== null && _l !== void 0 ? _l : 'America/New_York',
        },
        calendarFormat: {
            firstWeekDay: (_m = calendarFormat === null || calendarFormat === void 0 ? void 0 : calendarFormat.firstWeekDay) !== null && _m !== void 0 ? _m : 1,
            startDayHour: (_o = calendarFormat === null || calendarFormat === void 0 ? void 0 : calendarFormat.startDayHour) !== null && _o !== void 0 ? _o : 8,
            endDayHour: (_p = calendarFormat === null || calendarFormat === void 0 ? void 0 : calendarFormat.endDayHour) !== null && _p !== void 0 ? _p : 17,
            defaultCalView: (_q = calendarFormat === null || calendarFormat === void 0 ? void 0 : calendarFormat.defaultCalView) !== null && _q !== void 0 ? _q : 2,
        },
        distanceUnit: (_r = pref === null || pref === void 0 ? void 0 : pref.distanceUnit) !== null && _r !== void 0 ? _r : 'M',
        lang: (_s = pref.lang) !== null && _s !== void 0 ? _s : 'en',
        'sap-ui-language': sapUiLanguage !== null && sapUiLanguage !== void 0 ? sapUiLanguage : 'en-US',
        localeMode: pref === null || pref === void 0 ? void 0 : pref.localeMode,
    };
}
/**
 * Takes user data and builds a locale data object
 */
export function prepLocaleData(locale, lang, session, localeMode) {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j;
    var PreferenceDateFormat = session.PreferenceDateFormat;
    var dateFormat = (_a = preferenceBasedLongDateFormats[PreferenceDateFormat]) !== null && _a !== void 0 ? _a : {};
    var baseCurrency = session.DefaultEmpCurrencyCode || 'USD';
    var sapUiLanguage = longLangCodes[lang] || 'en-US';
    return {
        locale: locale,
        localeMode: localeMode,
        lang: lang,
        'sap-ui-language': sapUiLanguage,
        currencyFormat: {
            baseCurrency: baseCurrency,
            currencySign: getIntlSign((_b = session.NegativeCurrencyFormat) !== null && _b !== void 0 ? _b : 0),
            symbolLocation: session.PreferenceCurrencySymbolLocation ? 'after' : 'before',
            currencySymbol: (_c = getCurrencySymbols(baseCurrency)[baseCurrency]) !== null && _c !== void 0 ? _c : baseCurrency,
        },
        dateFormat: dateFormat,
        messages: {},
        numberFormat: {
            delimiters: prefDelimiters[(_d = session.PreferenceNumberFormat) !== null && _d !== void 0 ? _d : 0],
            numberSign: getIntlSign((_e = session.NegativeNumberFormat) !== null && _e !== void 0 ? _e : 0),
        },
        timeFormat: {
            hour12: !session.Preference24Hour,
            timeSeparator: session.PreferenceTimeFormat === 1 ? '.' : session.PreferenceTimeFormat === 2 ? ',' : ':',
            timeZone: session.TZName || 'America/New_York',
        },
        calendarFormat: {
            firstWeekDay: (_f = session.PreferenceFirstDayOfWeek) !== null && _f !== void 0 ? _f : 1,
            startDayHour: (_g = session.PreferenceStartDayViewHour) !== null && _g !== void 0 ? _g : 8,
            endDayHour: (_h = session.PreferenceEndDayViewHour) !== null && _h !== void 0 ? _h : 17,
            defaultCalView: (_j = session.PreferenceDefaultCalView) !== null && _j !== void 0 ? _j : 2,
        },
        distanceUnit: session.PrefDistanceUnit || 'M',
    };
}
export function getLocaleData(source) {
    var _a, _b;
    var localeData = (_b = (_a = source === null || source === void 0 ? void 0 : source.userPrefs) === null || _a === void 0 ? void 0 : _a.localeData) !== null && _b !== void 0 ? _b : source === null || source === void 0 ? void 0 : source.localeData;
    if (!localeData) {
        throw new TypeError('Locale Data information is not found');
    }
    if (!localeData.lang) {
        throw new TypeError('Language information in Locale Data is not found');
    }
    return localeData;
}
export var supportedLangModes = {
    empty: 'empty', // displays nothing
    codes: 'codes', // displays in the format: "[id]" and if a legacy id exists: "[id]-(legacyId)""
    prod: 'prod', // displays just the message id
    ids: 'ids', // displays just the message id (same as prod)
    upper: 'upper', // displays everything in upper case
    asian: 'asian', // appends the Chinese character "意" at the end of all strings
    dev: 'dev', // appends a single quote to the message
    steganography: 'steganography', // displays in the format: "{{{lang$$$id$$$category}}}formatted"
};
export function getLocaleMode(mode) {
    return supportedLangModes[mode];
}
